import { useRef, useState } from 'react';
import { Loader2, Send } from 'lucide-react';

export default function MessageComposer({
  onSend,
  disabled = false,
  isSending = false,
  placeholder = 'Write a message…',
  serviceCallId = null,
  serviceCallLabel = null,
  onClearServiceCall = null,
  linkPicker = null,
}) {
  const [input, setInput] = useState('');
  const inputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed || disabled || isSending) return;

    await onSend({
      body: trimmed,
      serviceCallId: serviceCallId || null,
    });
    setInput('');
    inputRef.current?.focus();
  };

  return (
    <form onSubmit={handleSubmit} className="px-4 py-3 border-t border-slate-200 flex-shrink-0 bg-white">
      {linkPicker}
      {!linkPicker && serviceCallLabel && (
        <div className="mb-2 flex items-center justify-between gap-2 rounded-md border border-primary-200 bg-primary-50 px-2.5 py-1.5 text-xs text-primary-800">
          <span className="truncate">Re: {serviceCallLabel}</span>
          {onClearServiceCall && (
            <button
              type="button"
              onClick={onClearServiceCall}
              className="flex-shrink-0 text-primary-600 hover:text-primary-800"
            >
              Remove
            </button>
          )}
        </div>
      )}

      <div className="flex items-end gap-2">
        <textarea
          ref={inputRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          placeholder={placeholder}
          disabled={disabled || isSending}
          rows={2}
          className="flex-1 resize-none rounded-lg border border-slate-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-50"
        />
        <button
          type="submit"
          disabled={disabled || isSending || !input.trim()}
          className="p-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700 disabled:opacity-50 flex-shrink-0"
        >
          {isSending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </button>
      </div>
    </form>
  );
}
